import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/root.types';

export const sessionTerminationSliceName = 'sessionTermination';

const getInitialState = () => ({
  lastActivityTimestamp: Date.now(),
  sessionAlertVisible: false,
  terminationActive: false,
});

export const sessionTerminationSlice = createSlice({
  name: sessionTerminationSliceName,
  initialState: getInitialState(),
  reducers: {
    setLastActivityTimestamp(state, action: PayloadAction<number>) {
      state.lastActivityTimestamp = action.payload;
    },
    setSessionAlertVisible(state, action: PayloadAction<boolean>) {
      state.sessionAlertVisible = action.payload;
    },
    setTerminationActive(state, action: PayloadAction<boolean>) {
      state.terminationActive = action.payload;
    },
    reset(state) {
      Object.assign(state, getInitialState());
    },
  },
});

export const { setLastActivityTimestamp, setSessionAlertVisible, setTerminationActive, reset } = sessionTerminationSlice.actions;

export const selectLastActivityTimestamp = (state: RootState) => {
  return state[sessionTerminationSliceName].lastActivityTimestamp;
};

export const selectTerminationActive = (state: RootState) => {
  return state[sessionTerminationSliceName].terminationActive;
};

export const selectSessionAlertVisible = (state: RootState) => {
  return state[sessionTerminationSliceName].sessionAlertVisible;
};
